import React from 'react';
import PropTypes from 'prop-types';
import Box from './Box.js';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { p as props } from './componentEl-33ff2aeb.js';
import { u as useLocalStorageSVG } from './useLocalStorageSVG-be835b86.js';
import './spacing-d13ff368.js';

/**
BrandSelect Item component
*/

function BrandSelectItem(_ref) {
  let {
    componentEl: Component,
    className,
    children,
    type
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children", "type"]);

  let cssClasses = ['st_brandselect__item', "st_brandselect__item--" + type];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' '),
    "aria-label": type
  }, otherProps), type && /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    className: "st_brandselect__logo"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st-brand-" + type
  })), !type && children);
}

BrandSelectItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** brand to display, if it exists */
  type: PropTypes.oneOf(['wsj', 'marketwatch', 'barrons', 'fnlondon', 'pen', 'mansionglobal', 'dowjones', 'thetimes', 'wsjopinion', 'ibd'])
};
BrandSelectItem.defaultProps = {
  componentEl: 'button',
  className: null,
  type: 'dowjones'
};
BrandSelectItem.displayName = 'BrandSelect.Item';

/**
BrandSelect component
*/

function BrandSelect({
  children,
  className,
  title
}) {
  const version = 3;
  useLocalStorageSVG({
    url: "https://screentone.djnews.tools/assets/brands-logos." + version + ".svg",
    id: 'st-brands-logos',
    version
  });
  let cssClasses = ['st_brandselect'];
  cssClasses = addClassNames(className, cssClasses);
  const count = React.Children.count(children);
  let columns = 0;
  if (count === 0) return null;

  if (count <= 4) {
    columns = count;
  } else if (count <= 6) {
    columns = 3;
  } else {
    columns = 4;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cssClasses.join(' ')
  }, /*#__PURE__*/React.createElement(Box, {
    className: "st_brandselect__box"
  }, /*#__PURE__*/React.createElement(Box.Title, null, title), /*#__PURE__*/React.createElement(Box.Content, {
    padding: {
      vertical: 'md',
      horizontal: 'mlg'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "st_brandselect__grid st_brandselect__grid--" + columns
  }, children))));
}

BrandSelect.propTypes = {
  /** title for Brand Select box */
  title: PropTypes.string,

  /** extra CSS classes, if any */
  className: classNameProps
};
BrandSelect.defaultProps = {
  title: 'Select Brand',
  className: null
};
BrandSelect.Item = BrandSelectItem;

export default BrandSelect;
